import {createAsyncThunk} from '@reduxjs/toolkit'
import AxiosClient from '../AxiosClient'
import {
  CreateSuperadminNewsPayload,
  SuperadminNewsFilters,
  UpdateSuperadminNewsPayload,
} from 'src/interfaces/SuperadminNews.interface'

const BASE_PATH = '/api/notifications'

export const getSuperadminNewsAsync = createAsyncThunk(
  'superadmin/getSuperadminNewsAsync',
  async (params: SuperadminNewsFilters, toolkit) => {
    return await AxiosClient('GET', BASE_PATH, [], toolkit, params)
  }
)

export const createSuperadminNewsAsync = createAsyncThunk(
  'superadmin/createSuperadminNewsAsync',
  async (payload: CreateSuperadminNewsPayload, toolkit) => {
    return await AxiosClient('POST', BASE_PATH, payload, toolkit, [])
  }
)

export const updateSuperadminNewsAsync = createAsyncThunk(
  'superadmin/updateSuperadminNewsAsync',
  async ({id, payload}: UpdateSuperadminNewsPayload, toolkit) => {
    return await AxiosClient('PUT', BASE_PATH, payload, toolkit, {id})
  }
)

export const deleteSuperadminNewsAsync = createAsyncThunk(
  'superadmin/deleteSuperadminNewsAsync',
  async (id: number, toolkit) => {
    return await AxiosClient('DELETE', BASE_PATH, [], toolkit, {id})
  }
)
